import styled from 'styled-components';

export const BannerImage = styled.img`
    height: 20rem;
    max-height: 20rem;
    align-self: center;
`;